// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\App\Users\Tenant\RolePermissions\Enums\TenantRolePermissionField
// Generated on: <normalized>

export enum TenantRolePermissionField {
  DB_TABLE = 'tenant_role_permissions',
  DB_IDENTIFIER = 'permissionGUID',
  ROLE_GUID = 'roleGUID',
  DEFINITION_SCOPE = 'definitionScope',
  PERMISSION_DEFINITION_GUID = 'permissionDefinitionGUID',
  ENABLED = 'enabled',
  CONDITIONS = 'conditions',
  CREATED_BY_USER_GUID = 'createdByUserGUID',
}

export const TenantRolePermissionFieldWritableFields = ["roleGUID", "definitionScope", "permissionDefinitionGUID", "enabled", "conditions"] as const;

export const TenantRolePermissionFieldGetEncryptionFields = [] as const;

export const TenantRolePermissionFieldCases = ["tenant_role_permissions", "permissionGUID", "roleGUID", "definitionScope", "permissionDefinitionGUID", "enabled", "conditions", "createdByUserGUID"] as const;
